import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PaymentService } from "../../../../../../mijn/src/app/activity/services/payment.service";
import { Payment } from "../../../../../../mijn/src/app/member/models/payment";
import { ModalComponent } from "../layout/modal/modal.component";
import { BasePage } from "../layout/pages/base-page";
import { ButtonComponent } from "../../form/components/button/button.component";
import { Product } from "../../../product/models/product";
import { UsageQuotaService } from "../../services/usage-quota.service";

@Component({
  selector: "app-usage-quota-package-modal",
  templateUrl: "./usage-quota-package-modal.component.html",
  standalone: true,
  imports: [
    CommonModule,
    ModalComponent,
    ButtonComponent,
  ],
})
export class UsageQuotaPackageModalComponent extends BasePage implements OnInit {
  @Input() quotaTypeId!: number;
  @Input() quotaTypeName!: string;
  @Input() paymentKey: string = "";
  @Input() blocked: boolean = false;
  @Output() upgrade = new EventEmitter<void>();

  packages: Product[] = [];
  selectedPackage: Product | null = null;
  payment: Payment | null = null;
  step = 1;

  constructor(
    protected override route: ActivatedRoute,
    modal: NgbModal,
    public activeModal: NgbActiveModal,
    private usageQuotaService: UsageQuotaService,
    private paymentService: PaymentService
  ) {
    super(route, modal);
  }

  ngOnInit(): void {
    if (this.paymentKey) {
      this.paymentService.check(this.paymentKey).subscribe((x) => {
        this.isLoading = false;
        this.payment = x;
        this.step = 3;
      });
    } else {
      this.loadPackages();
    }
  }

  loadPackages(): void {
    this.usageQuotaService.getPackages(this.quotaTypeId).subscribe({
      next: (data) => {
        this.packages = data;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  selectPackage(pkg: Product): void {
    this.selectedPackage = pkg;
    this.isLoading = true;
    const returnUrl = this.getRedirectUrl();
    this.usageQuotaService.pay(pkg.Id, returnUrl).subscribe({
      next: (url: string) => {
        debugger
        window.location.href = url;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  back(): void {
    this.step = 1;
    if (this.packages.length === 0) {
      this.loadPackages();
    }
  }

  private getRedirectUrl(): string {
    const url = window.location.href.split("?")[0];
    return url + "?paymentType=quota&paymentKey=";
  }
}
